var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55152 22.3919C5.61706 22.3919 3.89634 21.1533 3.27151 19.3094L3.22925 19.1704C3.08189 18.6821 3.02016 18.2715 3.02016 17.8606V9.62183L0.0887138 19.4072C-0.28831 20.8465 0.570835 22.3386 2.01233 22.7362L20.6973 27.7402C20.9305 27.8006 21.1637 27.8296 21.3934 27.8296C22.5968 27.8296 23.6965 27.0308 24.0047 25.8537L25.0933 22.3919H7.55152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8748 9.70396C12.2077 9.70396 13.2914 8.62002 13.2914 7.28716C13.2914 5.9543 12.2077 4.87036 10.8748 4.87036C9.54195 4.87036 8.45801 5.9543 8.45801 7.28716C8.45801 8.62002 9.54195 9.70396 10.8748 9.70396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9793 1.24536H7.85384C6.18888 1.24536 4.83301 2.60123 4.83301 4.26642V17.5583C4.83301 19.2234 6.18888 20.5793 7.85384 20.5793H25.9793C27.6445 20.5793 29.0003 19.2234 29.0003 17.5583V4.26642C29.0003 2.60123 27.6445 1.24536 25.9793 1.24536ZM7.85384 3.66216H25.9793C26.3129 3.66216 26.5835 3.93276 26.5835 4.26642V12.8446L22.7664 8.39044C22.3615 7.91562 21.7754 7.66184 21.1459 7.64746C20.52 7.651 19.9328 7.9289 19.5316 8.40991L15.0436 13.7967L13.5815 12.3381C12.7551 11.5117 11.4101 11.5117 10.5848 12.3381L7.24981 15.672V4.26642C7.24981 3.93276 7.52041 3.66216 7.85384 3.66216Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.c937723323b8e2fe8a82f040b57e7640.svg";
export { ForwardRef as ReactComponent };